import { jsxs, jsx } from "react/jsx-runtime";
const NotificationEmptyIcon = () => /* @__PURE__ */ jsxs("svg", { width: "200", height: "180", viewBox: "0 0 200 180", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M53.707 35.6569L65.4286 28.9547C71.064 25.7153 78.6154 25.4919 87.1812 28.843L75.4596 35.5452C66.8938 32.1941 59.3424 32.4175 53.707 35.6569Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M183.208 155.18L171.487 161.882C176.896 158.755 180.278 152.276 180.278 143.004C180.39 125.802 168.894 104.913 153.679 93.296L165.4 86.5938C180.616 98.211 191.999 119.1 191.999 136.302C191.999 145.574 188.731 152.052 183.208 155.18Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M84.5898 24.3757L96.3114 17.6734C103.637 13.4287 114.119 14.0989 125.615 20.6894C147.593 33.312 165.289 62.6903 165.401 86.7067L153.68 93.4089C153.567 69.5042 135.872 40.0143 113.894 27.3917C102.398 20.8012 91.9158 20.1309 84.5898 24.3757Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M153.679 93.2982C153.567 69.3934 135.871 39.9035 113.893 27.2809C96.0856 17.1158 80.7574 21.0255 75.5728 35.4353C57.2015 28.2863 43.4511 37.5577 43.3384 58.223C43.2257 81.2341 60.47 109.719 81.7718 121.894C82.8988 122.565 84.0259 123.123 85.153 123.682L147.593 159.539C148.157 159.874 148.72 160.097 149.171 160.209C166.415 169.257 180.166 161.773 180.166 143.118C180.391 125.804 168.895 104.915 153.679 93.2982Z",
      fill: "url(#paint0_linear)"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M47.9228 156.52V119.605H35.0088V156.52C35.0088 157.472 35.6729 158.425 36.9274 159.157C39.4364 160.622 43.5689 160.622 46.0779 159.157C47.3324 158.425 47.9228 157.472 47.9228 156.52Z",
      fill: "#DCDCDC"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M46.0785 116.97C48.5875 118.435 48.5875 120.778 46.0785 122.243C43.5695 123.708 39.4371 123.708 36.9281 122.243C34.4191 120.778 34.3453 118.435 36.9281 116.97C39.4371 115.505 43.4957 115.505 46.0785 116.97Z",
      fill: "#787878"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M44.3072 106.425C42.7575 105.546 40.1747 105.546 38.625 106.425C37.8133 106.864 37.4443 107.45 37.4443 108.036V118.803C37.4443 119.389 37.8133 119.975 38.625 120.414C40.1747 121.293 42.7575 121.293 44.3072 120.414C45.1189 119.975 45.4879 119.389 45.4879 118.803V108.036C45.4879 107.45 45.1189 106.864 44.3072 106.425Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M46.8896 96.9757C34.2708 89.7246 24.0873 72.2193 24.0873 57.7903C24.0873 50.6125 26.6701 45.6319 30.7287 43.2148L20.0286 49.4406C15.8961 51.7843 13.3871 56.8382 13.3871 64.016C13.3133 78.445 23.4969 95.9503 36.1157 103.201C42.462 106.864 48.2179 107.157 52.3504 104.813L63.0505 98.587C58.9919 101.004 53.2359 100.638 46.8896 96.9757Z",
      fill: "#787878"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: "0.4",
      d: "M39.2891 101.296C51.9079 108.547 62.1653 102.76 62.2391 88.3314C62.3128 73.9024 52.0555 56.3972 39.4367 49.1461C26.8179 41.895 16.5605 47.6812 16.4867 62.1102C16.4129 76.466 26.6703 94.0444 39.2891 101.296Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M36.3372 44.8974C51.9078 53.8331 64.5266 75.5133 64.5266 93.3115C64.4528 111.11 51.7602 118.288 36.1897 109.352C20.5453 100.416 7.92653 78.736 8.00032 60.9378C8.07412 43.1396 20.7667 35.9617 36.3372 44.8974ZM36.1159 103.126C48.7347 110.377 58.992 104.591 59.0658 90.162C59.1396 75.733 48.8822 58.2278 36.2635 50.9766C23.6447 43.7255 13.3873 49.5118 13.3135 63.9408C13.2397 78.3698 23.4971 95.9482 36.1159 103.126Z",
      fill: "#DCDCDC"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M46.9631 38.8191C39.0671 34.3512 31.9829 33.9117 26.8173 36.9147L16.1172 43.0672C21.2828 40.1374 28.367 40.5037 36.1892 45.0448C51.7597 53.9805 64.3785 75.6606 64.3785 93.4588C64.3785 102.321 61.2054 108.547 56.1136 111.477L66.8137 105.251C71.9055 102.321 75.0049 96.0956 75.0787 87.2331C75.1525 69.5081 62.5337 47.828 46.9631 38.8191Z",
      fill: "#AAAAAA"
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", { id: "paint0_linear", x1: "103.306", y1: "43.7443", x2: "80.0146", y2: "180.055", gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ jsx("stop", { stopColor: "#F4F4F4" }),
    /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#C9C9C9" })
  ] }) })
] });
export {
  NotificationEmptyIcon
};
//# sourceMappingURL=NotificationEmptyIcon.js.map
